import React, { useState } from "react";
import {
  ActiveCheckbox,
  EditButton,
  DeleteButton,
} from "../../common/TableCols";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Table, Button, Spin, Card, Row, Col } from "antd";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { RecordType } from "../../model/common/RecordType";
import FilterGridDropdown from "../../common/FilterGridDropdown";
import EntryFormFooter from "../../common/EntryFormFooter";
import { useTranslation } from "react-i18next";

export const TrainingsForm = ({
  isLoading,
  trainings,
  onAdd,
  onEdit,
  onDelete,
  onRowSelected,
  rowSelected,
  setCurrentPage,
  currentPage,
}) => {
  const { t } = useTranslation();

  const TrainingActiveCheckbox = (value) => (
    <ActiveCheckbox isChecked={value} />
  );

  const [searchTitleText, setSearchTitleText] = useState("");

  const TrainingActionButtons = (value, record) => (
    <Row>
      <Col span={12}>
        <EditButton fncEdit={() => onEdit(value)} />
      </Col>
      <Col
        span={12}
        style={{
          display: record.RcdType === RecordType.USER ? "" : "none",
        }}
      >
        <DeleteButton fncDelete={() => onDelete(value)} />
      </Col>
    </Row>
  );

  const handleSearchTitle = (selectedKeys, confirm) => {
    confirm();
    setSearchTitleText(selectedKeys[0]);
  };

  const handleResetTitle = (clearFilters) => {
    clearFilters();
    setSearchTitleText("");
  };

  const columns = [
    {
      title: t("trainingForm.training_start_date"),
      dataIndex: "TrainingFromDate",
      key: "TrainingFromDate",
      width: 160,
      sorter: (a, b) => dayjs(a.TrainingFromDate) - dayjs(b.TrainingFromDate),
      sortDirections: ["ascend", "descend"],
      render: (date) =>
        dayjs(date, "YYYY-MM-DD HH:mm").format("DD/MM/YYYY HH:mm"),
    },
    {
      title: t("trainingForm.training_end_date"),
      dataIndex: "TrainingToDate",
      key: "TrainingToDate",
      width: 160,
      sorter: (a, b) => dayjs(a.TrainingToDate) - dayjs(b.TrainingToDate),
      sortDirections: ["ascend", "descend"],
      render: (date) =>
        dayjs(date, "YYYY-MM-DD HH:mm").format("DD/MM/YYYY HH:mm"),
    },
    {
      title: t("general.title"),
      dataIndex: "Title",
      key: "Title",
      sorter: (a, b) => a.Title.localeCompare(b.Title),
      sortDirections: ["ascend", "descend"],
      ...FilterGridDropdown(
        "Title",
        searchTitleText,
        handleSearchTitle,
        handleResetTitle,
        "Title",
        t
      ),
    },
    {
      title: t("general.active"),
      dataIndex: "Active",
      key: "Active",
      align: "center",
      width: 100,
      render: TrainingActiveCheckbox,
    },
    {
      title: t("general.action"),
      dataIndex: "TrainingKey",
      key: "TrainingActions",
      align: "center",
      width: 100,
      render: TrainingActionButtons,
    },
  ];

  const tablePaginationChanged = (page) => {
    setCurrentPage(page);
  };

  return (
    <Card
      title={
        <span className="form-title">{t("trainingForm.training_setup")}</span>
      }
      extra={
        <Button
          icon={<PlusCircleOutlined />}
          size="large"
          type="primary"
          style={{ border: "1px solid #fff" }}
          onClick={() => onAdd()}
        >
          {t("general.new")}
        </Button>
      }
    >
      <Spin spinning={isLoading}>
        <Table
          dataSource={trainings}
          columns={columns}
          size="middle"
          rowKey={(record) => record.TrainingKey}
          scroll={{ y: "calc(100vh - 270px)" }}
          onRow={(r) => ({ onClick: () => onRowSelected(r) })}
          pagination={{
            defaultCurrent: currentPage,
            onChange: tablePaginationChanged,
          }}
        />
      </Spin>
      <EntryFormFooter
        footerData={rowSelected}
        showFooter={rowSelected.UpdatedBy ? true : false}
        isApproved={false}
        isVoid={false}
        isPending={false}
        t={t}
      ></EntryFormFooter>
    </Card>
  );
};

TrainingsForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  trainings: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRowSelected: PropTypes.func.isRequired,
  rowSelected: PropTypes.object.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
};
